export enum ObjectStates {
    UnderConstruction = 'underConstruction',
    InUse = 'inUse',
    InMaintenance = 'inMaintenance',
    OutOfService = 'outOfService',
    Deleted = 'deleted',
    Cancelled = 'cancelled',
}
